"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.wip.title': 'Lavori in corso',
    'socialMediaPlan.wip.description': 'Prossimamente.',
};
